import { render } from "./AsanaCallback.vue?vue&type=template&id=24578279&ts=true"
import script from "./AsanaCallback.vue?vue&type=script&lang=ts"
export * from "./AsanaCallback.vue?vue&type=script&lang=ts"

import "./AsanaCallback.vue?vue&type=style&index=0&id=24578279&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__